// Central asset registry for Ino Elites landing page (real photography).
export const LOGO =
  "https://customer-assets.emergentagent.com/job_build-your-site-149/artifacts/vs7bys1n_ComfyUI_temp_ngafc_00001_.png";

// City / hero — Shanghai skyline & Oriental Pearl / Shanghai Tower references
export const HERO_CITY =
  "https://images.pexels.com/photos/4870808/pexels-photo-4870808.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1100&w=1900";
export const CITY_TOWER =
  "https://images.pexels.com/photos/14586525/pexels-photo-14586525.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1100&w=880";
export const CITY_AERIAL =
  "https://images.pexels.com/photos/19243747/pexels-photo-19243747.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=800&w=1100";

// Arenas
export const ARENA_TUNNEL =
  "https://images.pexels.com/photos/4264244/pexels-photo-4264244.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=800&w=1100";
export const ARENA_CARNIVAL =
  "https://images.pexels.com/photos/20206645/pexels-photo-20206645.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=800&w=1100";

// Elites (placeholder neon portraits — to be replaced with real character art)
export const ELITE_SAYO =
  "https://images.pexels.com/photos/8107856/pexels-photo-8107856.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1100&w=880";
export const ELITE_RAIDEN =
  "https://images.pexels.com/photos/8108553/pexels-photo-8108553.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1100&w=880";
export const ELITE_YORUHA =
  "https://images.pexels.com/photos/23319089/pexels-photo-23319089.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1100&w=880";

// Playable genres / classes (transparent faction logos)
export const GENRE_ASTRYX =
  "https://customer-assets.emergentagent.com/job_build-your-site-149/artifacts/cz1jbqed_Astryx_Health_Group_Logo_-_Snake_Version-removebg.png";
export const GENRE_ZENITH =
  "https://customer-assets.emergentagent.com/job_build-your-site-149/artifacts/9t695q98_Zenith_Offense_Group_Logo-removebg.png";
export const GENRE_VANTA =
  "https://customer-assets.emergentagent.com/job_build-your-site-149/artifacts/99zoip0t_Vanta_Defense_Group_Logo-removebg.png";
